<div class="month" [class.datepicker-calendar]="!eventCalendar">
  @if (!eventCalendar) {
    <div class="month-label">{{ monthLabel }}</div>
  }
  <table [class.event-calendar]="eventCalendar" role="presentation">
    <thead class="mat-calendar-table-header">
      <tr>
        @for (day of weekdays; track day) {
          <th>{{ day }}</th>
        }
      </tr>
    </thead>
    @if (!eventCalendar) {
      <tbody
        myre-calendar-body
        [rows]="_weeksValue"
        [selectedValues]="selectedDatesInMonth"
        [todayValue]="_todayDate()"
        [activeCell]="_dateAdapter.getDate(activeDate) - 1"
        (selectedValueChange)="_dateSelected($event)"
      ></tbody>
    } @else {
      <tbody
        myre-event-calendar-body
        [rows]="_weeksValue"
        [canEdit]="canEdit"
        [todayValue]="_todayDate()"
        (onEventCreated)="onEventCreatedEmit($event)"
        (onEventUpdated)="onEventUpdatedEmit($event)"
      ></tbody>
    }
  </table>
</div>
